<!--
 * @Description: 排考 统一时间 添加考场
 * @Author: PF
 * @Date: 2023-04-24 10:02:43
 * @LastEditors: PF
 * @LastEditTime: 2023-04-28 10:50:37
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openKaoChang" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">添加考场</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openKaoChang', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="title mb20">{{kcmc}} 考场</div>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="97px">
        <el-row :gutter="20" class="wp100 mb10">
          <el-col :span="24">
            <el-form-item label="设置考试地点">
              <!-- 单选 BEGIN -->
              <div class="an-niu wp100" style="display: flex; align-items: center;">
                <el-button type="primary" class="w180" @click="openkscdDuoTiao=true">选择</el-button>
                <el-button class="ml10 mr10" link v-if="ruleForm.kcddmc" @click="ruleForm.kcddmc='';ruleForm.kcddid=''">清空</el-button>
                  <el-tag v-if="ruleForm.kcddmc" :disable-transitions="false">
                    {{ ruleForm.kcddmc }}
                  </el-tag>
              </div>
              <!-- 单选 END -->
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="容纳考生人数" prop="rnrs">
              <el-input-number v-model="ruleForm.rnrs" :min="0" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-form-item label="设置监考老师" class="wp100">
          <el-row :gutter="20" class="wp100 mb10" v-for="(item,index) in listKmccJkjs" :key="item.ccs">
            <el-col :span="3">
              <el-form-item>
                第{{item.ccs}}场
              </el-form-item>
            </el-col>
            <el-col :span="7">
              {{ item.kskmmc }}
            </el-col>
            <el-col :span="5">
              <el-button type="primary" class="wp100" @click="xuanXeJiaoShi(item, index)">选择</el-button>
            </el-col>
            <el-col :span="9">
              <span v-for="(val, i) in item.jzgxm" :key="i">
                <span v-if="i>0">、</span>
                <span>{{val}}</span>
              </span>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openKaoChang', emits, false)">取消</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <jiaozhigongduotiao v-if="openDuoTiao" v-model:openDuoTiao="openDuoTiao" :row="row" @ReturnData="jzgReturnData" />
  <jiaoxuechangdidantiao v-if="openkscdDuoTiao" v-model:openDanTiao="openkscdDuoTiao" :row="row" @ReturnData="kcddReturnData" />
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'
import { actionPost, loadSelect, closeWindow } from '@/api/common.js'
import { successPrompt, warningPrompt } from '@/utils/promptInfo.js'
import jiaozhigongduotiao from '@/components/chazhaodaihui/jiaozhigongduotiao'
import jiaoxuechangdidantiao from '@/components/chazhaodaihui/jiaoxuechangdidantiao'

const props = defineProps({
  openKaoChang: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openKaoChang', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({ rnrs: 0 })

const row = ref()
const kcmc = ref()

// 提交
const submit = () => {
  ruleForm.value.listKmccJkjs = listKmccJkjs.value.map((item) => ({
    menuId: sessionStorage.getItem('menuId'),
    ccid: item.ccid,
    jsid: item.jzgid,
    jskh: item.jskh,
    qskh: item.qskh
  }))
  ruleForm.value.menuId = sessionStorage.getItem('menuId')
  ruleForm.value.order = 'kccdmc'
  ruleForm.value.sort = 'asc'
  const o = { url: '/api/v2/jiaowu/kaowukaoshijihuapaikao/tianjiatongyishijiankaochang', data: ruleForm.value }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      closeWindow('openKaoChang', emits, true)
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
const listKmccJkjs = ref([])
watch(
  () => props.openKaoChang,
  () => {
    if (props.openKaoChang) {
      row.value = props.row
      
      listKmccJkjs.value = props.row.listKmcc || []
      listKmccJkjs.value.sort((a, b) => {
        return a.ccs - b.ccs
      })
      ruleForm.value.kcid = props.row.id || ''
      ruleForm.value.ksjhid = props.row.ksjhid || ''
      ruleForm.value.pkjhid = props.row.ksjhpkjhid || ''
      ruleForm.value.jxjhid = props.row.jxjhid
      ruleForm.value.kcddid = props.row.kcddid
      ruleForm.value.kcddmc = props.row.kccdmc
      ruleForm.value.rnrs = props.row.rnksrs
      kcmc.value = props.row.kch || ''
    }
  },
  { deep: true, immediate: true }
)
// 选择考试场地
const xqid = ref()
const openkscdDuoTiao = ref(false)
const kcddReturnData = (data) => {
  
  ruleForm.value.kcddid = data.id
  ruleForm.value.kcddmc = data.jsmc
}
// 删除考试场地
const kcddYiChu = () => {
  ruleForm.value.kcddid = ''
  ruleForm.value.kcddmc = ''
}
// 选择监考考教师
const dangQain = ref()
const openDuoTiao = ref(false)
const xuanXeJiaoShi = (item, index) => {
  dangQain.value = index
  openDuoTiao.value = true
}
const jzgReturnData = (item) => {
  listKmccJkjs.value[dangQain.value].jzgid = item.map((val) => val.id)
  listKmccJkjs.value[dangQain.value].jzgxm = item.map((val) => val.xm)
}
</script>

<style lang="less" scoped>
.title {
  font-size: 18px;
  font-weight: 600;
}
</style>
